var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layer-list-root" },
    [
      _vm.selectedRelease
        ? _c("div", { staticClass: "layer-list-container" }, [
            _c(
              "div",
              { staticClass: "data-panel" },
              [
                _c(
                  "b-row",
                  { staticClass: "mb-2", attrs: { "no-gutters": "" } },
                  [
                    _c("b-col", { attrs: { cols: "12" } }, [
                      _c(
                        "button",
                        {
                          staticClass: "change-region-btn",
                          attrs: { title: "Change Dataset" },
                          on: {
                            click: function ($event) {
                              return _vm.$bvModal.show("ptvReleaseModal")
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "change-region-icon",
                              attrs: {
                                viewBox: "0 0 16 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "8",
                                  cy: "8",
                                  r: "6.5",
                                  stroke: "currentColor",
                                  "stroke-width": "1.2",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M8 1.5C8 1.5 10.5 4 10.5 8S8 14.5 8 14.5M8 1.5C8 1.5 5.5 4 5.5 8S8 14.5 8 14.5M1.5 8h13",
                                  stroke: "currentColor",
                                  "stroke-width": "1.2",
                                  "stroke-linecap": "round",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Change Region")]),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { staticClass: "layer-list-font" }, [
                      _vm._v(
                        _vm._s(
                          this.getFormattedDate(
                            _vm.selectedRelease.release_date
                          )
                        ) +
                          " - " +
                          _vm._s(_vm.selectedRelease.extent_description)
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { staticClass: "layer-list-font" }, [
                      _vm._v(_vm._s(_vm.selectedRelease.release_label)),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "layers" },
              [
                _c(
                  "draggable",
                  [
                    _c(
                      "transition-group",
                      { attrs: { type: "transition", name: "flip-list" } },
                      _vm._l(_vm.layerButtons, function (element, index) {
                        return _c(
                          "b-row",
                          {
                            key: element.name,
                            staticClass: "layer-row",
                            class: _vm.getLayerClass(index, element),
                            attrs: { id: element.name.replace(/\s+/g, "_") },
                          },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "layer-btn",
                                attrs: { cols: "8" },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleLayer(element, $event)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "layer-row-label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.capitalizeFirstLetter(
                                        element.display_name
                                          ? element.display_name
                                          : element.name
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "layer-arrow layer-arrow--end",
                                attrs: { cols: "4" },
                              },
                              [
                                _c("fa", {
                                  staticClass: "cursor",
                                  attrs: {
                                    title: "Move Layer To Top",
                                    icon: ["fas", "long-arrow-alt-up"],
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toTopOfList(
                                        element.display_name
                                          ? element.display_name
                                          : element.name
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showTrailsPanel
        ? _c("TRT_TrailGroups", {
            attrs: {
              lidarMinZoomAchieved: _vm.lidarMinZoomAchieved,
              showTrailsPanel: _vm.showTrailsPanel,
              distinct_trails: _vm.distinct_trails,
              extentName: _vm.selectedExtent,
              trailsLoading: _vm.trailsLoading,
              map: _vm.map,
              selectedExtent: _vm.selectedExtent,
              zoomLevel: _vm.zoomLevel,
              selectedTrails: _vm.selectedTrails,
              cart: _vm.cart,
              disableTrailGroups: _vm.disableTrailGroups,
            },
            on: {
              onPointcloudClick: function ($event) {
                return _vm.$emit("onPointcloudClick", $event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }